import { render, staticRenderFns } from "./CheckoutTag.vue?vue&type=template&id=3c3a9fdd&scoped=true&"
import script from "./CheckoutTag.vue?vue&type=script&lang=js&"
export * from "./CheckoutTag.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutTag.vue?vue&type=style&index=0&id=3c3a9fdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3a9fdd",
  null
  
)

export default component.exports